export interface LaborForceBreakdown {
  civilianPopulation: string;
  civilianPopulationPercentage: number;
  employed: string;
  employedPercentage: number;
  laborForcePopulation: string;
  laborForcePopulationPercentage: number;
  notInLaborForce: string;
  notInLaborForcePercentage: number;
  totalPopulation: string;
  under16: string;
  under16Percentage: number;
  unemployed: string;
  unemployedPercentage: number;
}

export interface Coordinates {
  latitude: number;
  longitude: number;
}

export interface IndustryOrOccupation {
  change: number;
  changePercentage: string;
  cyCount: number;
  name: string;
  pyCount: number;
}

export interface IndustriesOrOccupations {
  top: IndustryOrOccupation[];
  bottom: IndustryOrOccupation[];
}

export interface IndustriesChartProps {
  industries: IndustryOrOccupation[];
}

export interface OccupationChartProps {
  occupations: IndustryOrOccupation[];
}

export interface RegionalContext {
  coordinates: Coordinates;
  countyCodes: string[];
  mapId: string;
  mapTilerApiKey: string;
  noOfCounties: number;
  radius: number;
  timeFrame: string;
  zip: number;
}

export interface RegionalContextInterface {
  regionalContext: RegionalContext;
  showLightcastWidget: Boolean;
}

export interface Timeframe {
  currentYear: number | null;
  pastYear: number | null;
}

export interface PopulationTrendsInterface {
  change: number;
  changePercentage: number;
  inclined: boolean;
  totalPopulation: number;
}

export interface LaborForceTrend {
  laborForceGrowthIncrease: boolean;
  laborForceGrowthPercentageFrom: number;
  laborForceGrowthPercentageTo: number;
  laborForcePercentage: number;
  unemploymentGrowthIncrease: boolean;
  unemploymentGrowthPercentageFrom: number;
  unemploymentGrowthPercentageTo: number;
  unemploymentPercentage: number;
}

export interface JobTrendsInterface {
  JobsNationalRateGrowthIncrease: boolean;
  jobsFromTotalCount: number;
  jobsGrowthIncrease: boolean;
  jobsNationalRatePercentage: number;
  jobsPercentage: number;
  jobsToTotalCount: number;
}

export interface LaborForceTrendsInterface {
  jobTrends: JobTrendsInterface;
  laborForceBreakdown: LaborForceBreakdown;
  laborForceTrends: LaborForceTrend;
  populationTrends: PopulationTrendsInterface;
  timeframe: Timeframe;
}

export const defaultLaborForceBreakdown = {
  civilianPopulation: "",
  civilianPopulationPercentage: 0,
  employed: "",
  employedPercentage: 0,
  laborForcePopulation: "",
  laborForcePopulationPercentage: 0,
  notInLaborForce: "",
  notInLaborForcePercentage: 0,
  totalPopulation: "",
  under16: "",
  under16Percentage: 0,
  unemployed: "",
  unemployedPercentage: 0
};

export const defaultCoordinates = {
  latitude: 0,
  longitude: 0
};

export const defaultRegionalContext = {
  coordinates: defaultCoordinates,
  countyCodes: [],
  mapId: "",
  mapTilerApiKey: "",
  noOfCounties: 0,
  radius: 0,
  timeFrame: "",
  zip: 0
};

export interface Tab {
  name: string;
  id: string;
}

export interface County {
  name: string;
  population: number;
  percentage: number;
  code: string;
}
